import React from "react";

const RadarComponent = () => {
  return (
    <div style={styles.wrapper}>
      {/* Map container */}
      <div style={styles.mapContainer}></div>

      {/* Radar Container */}
      <div style={styles.radarContainer}>
        <div style={styles.radar}>
          <div style={styles.pulse}></div>
          <div style={{ ...styles.pulse, animationDelay: "1s" }}></div>
          <div style={{ ...styles.pulse, animationDelay: "2s" }}></div>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse-animation {
          0% {
            width: 0;
            height: 0;
            opacity: 0.5;
          }
          50% {
            opacity: 1;
          }
          100% {
            width: 400px;
            height: 400px;
            opacity: 0.3;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  wrapper: {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
  },
  mapContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    zIndex: 1, // Map is behind the radar
  },
  radarContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "400px",
    height: "400px",
    borderRadius: "50%",
    overflow: "hidden",
    transform: "translate(-50%, -50%)", // Center the radar in the viewport
    zIndex: 100, // Radar stays on top of the map
  },
  radar: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    boxShadow: "0 0 100px 20px rgba(230, 48, 16, 0.9)",
  },
  pulse: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "",
    height: "",
    transform: "translate(-50%, -50%)",
    borderRadius: "50%",
    border: "5px solid rgba(238, 31, 8, 0.7)", // Clear circle effect
    animation: "pulse-animation 2.5s infinite linear",
  },
};

export default RadarComponent;
